import React, {useEffect, useRef, useState, useContext} from 'react';
import propTypes from 'prop-types';
import _ from 'lodash';
import classnames from 'classnames';
import { parallax } from '_ui-core-js/libraries/parallax.js';
import { Picture } from '_ui-core-js/React/components/Picture.jsx';
import { BREAKPOINT_DEFINITIONS } from '_ui-core-js/constants/config.js';
import { isOddNumber } from '_ui-core-js/utilities/isOddNumber.js'
import { CssAnimation } from '_ui-core-js/React/components/CssAnimation.jsx';
import { inView } from '_ui-core-js/libraries/inView.js';
import { useBreakpointChange } from '_ui-core-js/React/hooks/useBreakpointChange.js';
import { EditiorialHeading, EditiorialParallaxImages } from '../../partials';
import { NavigationContext } from '../../store/contexts/NavigationContext';

export function AtmosphereEditorial(props) {

  
    const { sections = [], atmosphere } = props;
    const block = 'c-atmosphere-editiorial';
    const [smallView, setSmallView] = useState(!useBreakpointChange((breakpoint, largerThanPivotBp) => {
        setSmallView(!largerThanPivotBp);
      }, 'md' )[1]);

    const parallaxRef = useRef();
    const inViewRef = useRef();
    const rootElRef = useRef();
    const { navigate } = useContext(NavigationContext);
    
    useEffect(() => {
        inViewRef.current = inView({
            root: rootElRef.current,
            selector: '[data-parallax-target]',
            threshold: 0.1,
            activeClass: 'parallax-active',
            inactiveClass: 'parallax-inactive'
        }).init();

        setTimeout(() => {
            parallaxRef.current = parallax({
                rootElement: rootElRef.current,
                selector: '[data-parallax-target]',
                trigger: 'scroll',
                scrollRestoration: 'smoothScroll',
                minActiveBreakpoint: BREAKPOINT_DEFINITIONS.md
            });
            parallaxRef.current.init();
        }, 0);
        return () => {
            parallaxRef.current.destroy();
            inViewRef.current.destroy();
        };
    }, []);

    return <article className={block} id="your-atmosphere-editorial" ref={rootElRef} >
        {_.map( sections, (section, index) => {

            const { copy, divider, images, subtitle, title } = section;
            const isOddItem = isOddNumber(index);
            
            return ( 
                <section 
                    className={`${block}__section utils__section-padding-small--top`} 
                    key={`${atmosphere}-content-section-${index}`}>
                    <div className={ 
                        classnames({
                            [`${block}__content`]: true,
                            [`${block}__content--alternate`]: isOddItem,
                        })}>
                    
                        { images && 
                            <EditiorialParallaxImages {...{
                                block,
                                images
                            }}/>
                        }
                    
                        <div className={`${block}__text-container`}>
                            { title && 
                                <EditiorialHeading {...{
                                    applyLbxTheme: true,
                                    block,
                                    subtitle,
                                    title
                                }}/>
                            }
                            { copy && 
                                <p className={`${block}__copy editorial-copy`}>{copy}</p>
                            }
                        </div>
                    </div>
                    { divider && 
                        <div className={
                            classnames({
                                [`${block}__divider`]: true,
                                [`${block}__divider--contained-image`]: isOddItem,
                                'container-xxl': !smallView
                            })}>
                            <CssAnimation 
                                enter={{ name: 'slide-up', duration: 1, easing: 'ease-out' }} 
                                triggerEnter={'in-view-init'}
                            >   
                                <div className='utils__add-expand-icon-before'>
                                    <Picture {...{
                                        ...divider,
                                        onClick: () =>{
                                            let path = '/inspiration'
                                            
                                            if (divider.id) {
                                                path += '/' + divider.id;
                                            }
                                                
                                            navigate(path);
                                          }
                                    }}/>
                                </div>    
                            </CssAnimation>
                        </div> 
                    } 
                </section>
            )
        })}
    </article>
}

AtmosphereEditorial.propTypes = {
    atmosphere: propTypes.string
}; 